import React, { useEffect } from "react";
import { connect } from "react-redux";
import { RouteComponentProps, StaticContext } from "react-router";
import BankOfferItem from "src/components/MyGarage/BankOffers/BankOfferItem";
import DrawerWrapper from "src/components/MyGarage/DrawerWrapper/Blocks/DrawerWrapper";
import { ApplicationStore } from "src/store";
import { toggleGarageDrawer } from "src/store/actions/garageDrawer.ts";
import { patchPaymentsRequest } from "src/store/actions/payments";
import {
    getSelectedOfferIndex,
    getSelectedPaymentOffers,
    getSelectedPaymentType,
    getVehicle,
} from "src/store/selectors/vehicles";

type RouteProps = RouteComponentProps<{}, StaticContext, { vin: string }>;

const BankOffersDrawer = ({
    history,
    offers,
    patchPayments,
    paymentType,
    selectedOfferId,
    toggleDrawer,
    uuid,
    vehicle,
    vin,
}: ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps & RouteProps) => {
    // If you open the drawer then change something in the grid, you can get into a state where the drawer can't display offers and needs to close itself
    useEffect(() => {
        if (paymentType === "cash" || offers.length <= 1) {
            toggleDrawer();
            history.push("/my-garage", history.location.state);
        }
    }, [paymentType, offers, history, toggleDrawer]);

    if (paymentType === "cash" || offers.length <= 1) {
        return null;
    }

    const setSelected = (key: number) => {
        patchPayments(
            uuid,
            vin,
            {
                [paymentType]: {
                    selected_offer: key,
                },
            },
            "patch_payment_selected_offer"
        );
    };

    return (
        <DrawerWrapper title="MyGarage.BankOffers.title" translateTitle={true} vin={vin}>
            {offers.map((offer, id) => (
                <BankOfferItem
                    id={id}
                    key={`bankOfferItem_${vin}_${id}`}
                    selected={selectedOfferId}
                    offer={offer}
                    onUpdate={setSelected}
                    vehicle={vehicle}
                    vin={vin}
                />
            ))}
        </DrawerWrapper>
    );
};

const mapStateToProps = (
    state: ApplicationStore,
    {
        location: {
            state: { vin },
        },
    }: RouteProps
) => ({
    uuid: state.deal.uuid!,
    paymentType: getSelectedPaymentType(state, vin),
    vehicle: getVehicle(state, vin),
    vin,
    offers: getSelectedPaymentOffers(state, vin),
    selectedOfferId: getSelectedOfferIndex(state, vin),
});

const mapDispatchToProps = {
    patchPayments: patchPaymentsRequest,
    toggleDrawer: toggleGarageDrawer,
};

export default connect(mapStateToProps, mapDispatchToProps)(BankOffersDrawer);
